import { createSvgComponent } from "../../icon/createSvgComponent";
import Phone from "@core/__generated__/icon/figma/phone.svg";
export default createSvgComponent(Phone);